var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5271 11.5221L16.138 16.131M11.5271 16.131L16.138 11.5221M8.06894 19.5876C11.2389 22.7562 16.4261 22.7562 19.5961 19.5876C22.7661 16.419 22.7661 11.2341 19.5961 8.06548C16.4261 4.89689 11.2389 4.89689 8.06894 8.06548C4.89897 11.2341 4.89897 16.419 8.06894 19.5876Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.558,
    height: 19.558,
    fill: "white",
    transform: "matrix(0.707261 0.706953 -0.707261 0.706953 13.8325 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.e086f19656b76b2bcacb4059371fdb9e.svg";
export { ForwardRef as ReactComponent };